import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {closePropatiesModal} from '../../redux/counterSlice';

interface Properties {
  type: string;
  description: string;
  onAdd?: () => void;
  onSave: (value: any) => void;
}
export interface Attributes {
  trait_type: string;
  value: string;
  max_value?: string;
  nusa_attribute_type: string;
}

const Proparties_modal = ({type, description, onSave}: Properties) => {
  const {propartiesModalValue} = useSelector((state: any) => state.counter);
  const dispatch = useDispatch();
  const [isDisabledSave, setIsDisabledSave] = useState<boolean>(false);

  const [termProperties, setTermProperties] = useState<any>([]);
  const [termLevels, setTermLevels] = useState<any>([]);
  const [termStats, setTermStats] = useState<any>([]);

  const [formProperties, setFormProperties] = useState<Array<Attributes>>([
    {trait_type: '', value: '', nusa_attribute_type: 'PROPERTIES'},
  ]);
  const [formLevels, setFormLevels] = useState<Array<Attributes>>([
    {trait_type: '', value: '', max_value: '', nusa_attribute_type: 'LEVELS'},
  ]);
  const [formStats, setFormStats] = useState<Array<Attributes>>([
    {trait_type: '', value: '', max_value: '', nusa_attribute_type: 'STATS'},
  ]);

  const handleChange = (i: number, e: React.ChangeEvent<HTMLInputElement>) => {
    if (type === 'Properties') {
      let newFormValues: any = [...formProperties];
      newFormValues[i][e.target.name] = e.target.value.toString();
      setFormProperties(newFormValues);
    } else if (type === 'Levels' || type === 'Stats') {
      let val: any = e.target.value;
      if (e.target.name === 'value' || e.target.name === 'max_value') {
        val = parseInt(val, 10);
        if (isNaN(val)) {
          val = 0;
        } else {
          val = val >= 0 ? val : 0;
        }
      }
      if (type === 'Levels') {
        let newFormValues: any = [...formLevels];
        newFormValues[i][e.target.name] = val.toString();
        setFormLevels(newFormValues);
      } else {
        let newFormValues: any = [...formStats];
        newFormValues[i][e.target.name] = val.toString();
        setFormStats(newFormValues);
      }
    }
  };

  const resetForm = () => {
    if (type === 'Properties') {
      setFormProperties([{trait_type: '', value: '', nusa_attribute_type: 'PROPERTIES'}]);
    } else if (type === 'Levels') {
      setFormLevels([{trait_type: '', value: '', max_value: '', nusa_attribute_type: 'LEVELS'}]);
    } else if (type === 'Stats') {
      setFormStats([{trait_type: '', value: '', max_value: '', nusa_attribute_type: 'STATS'}]);
    }
  };

  const addForm = (type: string) => {
    if (type === 'Properties')
      setFormProperties([
        ...formProperties,
        {trait_type: '', value: '', nusa_attribute_type: 'PROPERTIES'},
      ]);
    else if (type === 'Levels')
      setFormLevels([
        ...formLevels,
        {trait_type: '', value: '', max_value: '', nusa_attribute_type: 'LEVELS'},
      ]);
    else if (type === 'Stats')
      setFormStats([
        ...formStats,
        {trait_type: '', value: '', max_value: '', nusa_attribute_type: 'STATS'},
      ]);
  };

  const removeForm = (i: number) => {
    if (type === 'Properties') {
      let newFormValues = [...formProperties];
      newFormValues.splice(i, 1);
      setFormProperties(newFormValues);
    } else if (type === 'Levels') {
      let newFormValues = [...formLevels];
      newFormValues.splice(i, 1);
      setFormLevels(newFormValues);
    } else if (type === 'Stats') {
      let newFormValues = [...formStats];
      newFormValues.splice(i, 1);
      setFormStats(newFormValues);
    }
  };

  const closeModal = () => {
    if (type === 'Properties') {
      let newValues: any = [];
      termProperties.forEach((item: any, index: number) => {
        newValues.push({
          trait_type: item.a,
          value: item.b,
          nusa_attribute_type: 'PROPERTIES',
        });
      });
      if (newValues.length > 0) setFormProperties(newValues);
    } else if (type === 'Levels') {
      let newValues: any = [];
      termLevels.forEach((item: any, index: number) => {
        newValues.push({
          trait_type: item.a,
          value: item.b,
          max_value: item.c,
          nusa_attribute_type: 'LEVELS',
        });
      });
      if (newValues.length > 0) setFormLevels(newValues);
    } else if (type === 'Stats') {
      let newValues: any = [];
      termStats.forEach((item: any, index: number) => {
        newValues.push({
          trait_type: item.a,
          value: item.b,
          max_value: item.c,
          nusa_attribute_type: 'STATS',
        });
      });
      if (newValues.length > 0) setFormStats(newValues);
    }
  };

  const saveValue = () => {
    if (type === 'Properties') {
      setTermProperties([]);
      formProperties.forEach((item: Attributes) => {
        if (item.trait_type !== '' && item.value !== '')
          setTermProperties((state: Array<Attributes>) => [
            ...state,
            {
              a: item.trait_type,
              b: item.value,
            },
          ]);
      });
    } else if (type === 'Levels') {
      setTermLevels([]);
      formLevels.forEach((item: Attributes) => {
        if (item.trait_type !== '' && item.value !== '' && item.max_value !== '')
          setTermLevels((state: Array<Attributes>) => [
            ...state,
            {
              a: item.trait_type,
              b: item.value,
              c: item.max_value,
            },
          ]);
      });
    } else if (type === 'Stats') {
      setTermStats([]);
      formStats.forEach((item: Attributes) => {
        if (item.trait_type !== '' && item.value !== '' && item.max_value !== '')
          setTermStats((state: Array<Attributes>) => [
            ...state,
            {
              a: item.trait_type,
              b: item.value,
              c: item.max_value,
            },
          ]);
      });
    }

    let allAttributes: any = [];
    if (formProperties[0].trait_type !== '') allAttributes = [...allAttributes, ...formProperties];
    if (formLevels[0].trait_type !== '') allAttributes = [...allAttributes, ...formLevels];
    if (formStats[0].trait_type !== '') allAttributes = [...allAttributes, ...formStats];
    onSave(allAttributes);
  };

  useEffect(() => {
    if (type === 'Properties') {
      formProperties.forEach((item, index) => {
        if (formProperties.length === 1) {
          if (
            (item.trait_type === '' && item.value === '') ||
            (item.trait_type !== '' && item.value !== '')
          )
            setIsDisabledSave(false);
          else setIsDisabledSave(true);
        } else if (formProperties.length > 1) {
          if (item.trait_type !== '' && item.value !== '') setIsDisabledSave(false);
          else setIsDisabledSave(true);
        }
      });
    } else if (type === 'Levels' || type === 'Stats') {
      const form = type === 'Levels' ? formLevels : formStats;
      const arrayValue: any = [];
      form.forEach((item, index) => {
        if (form.length === 1) {
          if (
            (item.trait_type === '' && item.value === '' && item.max_value === '') ||
            (item.trait_type !== '' &&
              item.value !== '' &&
              item.max_value !== '' &&
              Number(item.max_value) >= Number(item.value))
          )
            setIsDisabledSave(false);
          else setIsDisabledSave(true);
        } else if (form.length > 1) {
          arrayValue.push(Number(item.max_value) >= Number(item.value));
          if (
            item.trait_type !== '' &&
            item.value !== '' &&
            item.max_value !== '' &&
            !arrayValue.includes(false)
          )
            setIsDisabledSave(false);
          else setIsDisabledSave(true);
        }
      });
    }
  }, [formProperties, formLevels, formStats]);

  return (
    <div>
      <div className={propartiesModalValue ? 'modal fade show block' : 'modal fade'}>
        <div className="modal-dialog max-w-2xl w-full">
          <div className="modal-content !bg-none">
            <div className="modal-header">
              <h5 className="modal-title" id="addPropertiesLabel">
                Add {type}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => {
                  closeModal();
                  dispatch(closePropatiesModal());
                }}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.912 5.02948L11.999 10.9425L6.08604 5.02948C5.94382 4.89934 5.75688 4.82909 5.56415 4.83336C5.37142 4.83763 5.18777 4.91609 5.05146 5.0524C4.91515 5.18872 4.83669 5.37236 4.83242 5.56509C4.82814 5.75782 4.8984 5.94476 5.02854 6.08698L10.9385 12L5.02704 17.9115C4.95482 17.9803 4.89708 18.0629 4.85723 18.1543C4.81738 18.2458 4.79621 18.3443 4.79498 18.4441C4.79374 18.5438 4.81246 18.6428 4.85004 18.7352C4.88761 18.8277 4.94328 18.9116 5.01378 18.9822C5.08427 19.0528 5.16817 19.1086 5.26053 19.1463C5.3529 19.184 5.45187 19.2029 5.55163 19.2018C5.65139 19.2007 5.74992 19.1797 5.84144 19.1399C5.93296 19.1002 6.01561 19.0426 6.08454 18.9705L11.999 13.059L17.912 18.972C18.0543 19.1021 18.2412 19.1724 18.4339 19.1681C18.6267 19.1638 18.8103 19.0854 18.9466 18.9491C19.0829 18.8127 19.1614 18.6291 19.1657 18.4364C19.1699 18.2436 19.0997 18.0567 18.9695 17.9145L13.0565 12.0015L18.9695 6.08698C19.0418 6.01815 19.0995 5.93558 19.1393 5.84412C19.1792 5.75266 19.2004 5.65416 19.2016 5.5544C19.2028 5.45464 19.1841 5.35564 19.1465 5.26323C19.109 5.17081 19.0533 5.08683 18.9828 5.01624C18.9123 4.94564 18.8284 4.88985 18.736 4.85215C18.6437 4.81444 18.5447 4.79558 18.4449 4.79668C18.3452 4.79777 18.2467 4.8188 18.1551 4.85852C18.0636 4.89824 17.981 4.95586 17.912 5.02798V5.02948Z"
                    fill="#9AA09D"
                  />
                </svg>
              </button>
            </div>

            {/* <!-- Body --> */}
            <div className="modal-body p-6">
              <p className="dark:text-grey text-dark-grey mb-8">{description}</p>

              {type === 'Properties'
                ? formProperties.map((element, index) => (
                    <div key={index} className="relative my-3 flex items-center">
                      <button
                        className="dark:bg-white/[.30] dark:border-grey hover:bg-jacarta-100 border-jacarta-100 bg-white/[.30] flex h-12 w-12 shrink-0 items-center justify-center self-end rounded-l-lg border border-r-0"
                        onClick={() =>
                          formProperties.length > 1 ? removeForm(index) : resetForm()
                        }
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width="24"
                          height="24"
                          className="fill-grey h-6 w-6"
                        >
                          <path fill="none" d="M0 0h24v24H0z"></path>
                          <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"></path>
                        </svg>
                      </button>

                      <div className="flex-1">
                        {index === 0 && (
                          <label className="font-display text-dark-navy mb-3 block text-base font-semibold dark:text-white">
                            Type
                          </label>
                        )}
                        <input
                          type="text"
                          className="dark:bg-black-green px-4 dark:border-grey focus:ring-accent border-jacarta-100 placeholder-grey h-12 w-full border border-r-0 focus:ring-inset dark:text-white"
                          placeholder="Character"
                          value={element.trait_type || ''}
                          onChange={(e) => handleChange(index, e)}
                          name="trait_type"
                        />
                      </div>

                      <div className="flex-1">
                        {index === 0 && (
                          <label className="font-display text-dark-navy mb-3 block text-base font-semibold dark:text-white">
                            Name
                          </label>
                        )}
                        <input
                          type="text"
                          className="dark:bg-black-green px-4 dark:border-grey focus:ring-accent border-jacarta-100 placeholder-grey h-12 w-full rounded-r-lg border focus:ring-inset dark:text-white"
                          placeholder="Male"
                          value={element.value || ''}
                          onChange={(e) => handleChange(index, e)}
                          name="value"
                        />
                      </div>
                    </div>
                  ))
                : (type === 'Levels' ? formLevels : formStats).map((element, index) => (
                    <div key={index} className="relative my-3 flex items-center">
                      <button
                        className="dark:bg-white/[.30] dark:border-grey hover:bg-jacarta-100 border-jacarta-100 bg-white/[.30] flex h-12 w-12 shrink-0 items-center justify-center self-end rounded-l-lg border border-r-0"
                        onClick={() =>
                          (type === 'Levels' ? formLevels : formStats).length > 1
                            ? removeForm(index)
                            : resetForm()
                        }
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width="24"
                          height="24"
                          className="fill-jacarta-500 dark:fill-jacarta-300 h-6 w-6"
                        >
                          <path fill="none" d="M0 0h24v24H0z"></path>
                          <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"></path>
                        </svg>
                      </button>

                      <div className="flex-1">
                        {index === 0 && (
                          <label className="font-display text-dark-navy mb-3 block text-base font-semibold dark:text-white">
                            Name
                          </label>
                        )}
                        <input
                          type="text"
                          className="dark:bg-black-green px-4 dark:border-grey focus:ring-accent border-jacarta-100 placeholder-grey h-12 w-full border border-r-0 focus:ring-inset dark:text-white"
                          placeholder="Speed"
                          value={element.trait_type || ''}
                          onChange={(e) => {
                            handleChange(index, e);
                          }}
                          name="trait_type"
                        />
                      </div>

                      <div className="flex-1">
                        {index === 0 && (
                          <label className="font-display text-dark-navy mb-3 block text-base font-semibold dark:text-white">
                            Value
                          </label>
                        )}
                        <div className="flex">
                          <input
                            type="number"
                            className="dark:bg-black-green px-4 dark:border-grey focus:ring-accent border-jacarta-100 placeholder-grey h-12 w-full border border-r-0 focus:ring-inset dark:text-white"
                            placeholder="0"
                            value={element.value || ''}
                            onChange={(e) => handleChange(index, e)}
                            name="value"
                            min={0}
                          />
                          <div className="flex items-center px-4 bg-white/[.30] border-y border-grey text-grey">
                            Of
                          </div>
                          <input
                            type="number"
                            className="dark:bg-black-green px-4 dark:border-grey focus:ring-accent border-jacarta-100 placeholder-grey h-12 w-full rounded-r-lg border border-l-0 focus:ring-inset dark:text-white"
                            placeholder="5"
                            value={element.max_value || ''}
                            onChange={(e) => handleChange(index, e)}
                            name="max_value"
                            min={0}
                          />
                        </div>
                      </div>
                    </div>
                  ))}

              <div className="rounded-full p-[1px] bg-green-gradation w-max mt-5">
                <button
                  className="dark:bg-black-green bg-white rounded-full py-2.5 px-8  text-sm dark:text-white w-full"
                  onClick={() => addForm(type)}
                >
                  <span className="font-medium flex items-center justify-center text-sm  text-transparent bg-clip-text bg-green-gradation">
                    Add More
                  </span>
                </button>
              </div>
            </div>
            {/* <!-- end body --> */}

            <div className="modal-footer">
              <div className="flex items-center justify-center space-x-4">
                <button
                  type="button"
                  className={` rounded-full py-3 px-8 text-center font-semibold text-white transition-all ${
                    isDisabledSave ? 'bg-black-green' : 'bg-green-gradation-light'
                  }`}
                  onClick={() => {
                    saveValue();
                    dispatch(closePropatiesModal());
                  }}
                  disabled={isDisabledSave}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Proparties_modal;
